"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const user_state_enum_1 = require("../enums/user-state.enum");
class RequestMapper {
    static decodeResponseData(responseData) {
        if (!!responseData.results) {
            return {
                items: responseData.results.map((responseDataItem) => this.decodeUser(responseDataItem)),
                total: responseData.numFound
            };
        }
        return RequestMapper.decodeUser(responseData);
    }
    static decodeUser(json) {
        return {
            id: json.id,
            username: json.username,
            firstName: json.first_name,
            lastName: json.last_name,
            email: json.email,
            consent: json.consent,
            enabled: (json.state === user_state_enum_1.UserStateEnum.ENABLED),
            password: undefined,
            consentDate: (!!json.consent_date ? new Date(json.consent_date) : undefined),
            authorization: (!!json.authorization ? this.decodeAuthorization(json.authorization) : {})
        };
    }
    static encodeUserPOST(user, multiInstanceSupported) {
        return {
            first_name: user.firstName,
            last_name: user.lastName,
            email: user.email,
            state: (user.enabled ? user_state_enum_1.UserStateEnum.ENABLED : user_state_enum_1.UserStateEnum.DISABLED),
            username: user.username,
            consent: user.consent,
            password: user.password,
            password_confirm: user.passwordConfirm,
            consent_date: user.consentDate,
            authorization: (!!user.authorization ? this.encodeAuthorization(user.authorization, multiInstanceSupported) : undefined)
        };
    }
    static encodeUserPUT(user) {
        return {
            first_name: user.firstName,
            last_name: user.lastName,
            password: user.password,
            password_confirm: user.passwordConfirm
        };
    }
    static encodeRequestPage(page) {
        if (!!page) {
            return {
                rows: page.rows,
                offset: page.start
            };
        }
    }
    static decodeAuthorization(authorization) {
        return authorization.reduce((decodedAuthorization, auth) => {
            decodedAuthorization[auth.instance] = auth.roles;
            return decodedAuthorization;
        }, {});
    }
    static encodeAuthorization(authorization, multiInstanceSupported) {
        if (multiInstanceSupported) {
            return Object.keys(authorization).map((instance) => {
                return {
                    instance: instance,
                    roles: authorization[instance]
                };
            });
        }
        else {
            return Object.values(authorization)[0];
        }
    }
    static decodeInvite(invite) {
        return {
            email: invite.email,
            jwt_extra: invite.jwt_extra,
            authorization: invite.authorization
        };
    }
    static encodeInvitePOST(invite) {
        return {
            email: invite.email,
            jwt_extra: invite.jwt_extra,
            authorization: invite.authorization
        };
    }
}
exports.RequestMapper = RequestMapper;
//# sourceMappingURL=data:application/json;base64,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